import { MyLensesLensStatus, type SurfaceType } from "../../../gql-generated/types";

type BusinessLensStatuses =
    | typeof MyLensesLensStatus.LensStatusFinalized
    | typeof MyLensesLensStatus.LensStatusFinalizing
    | typeof MyLensesLensStatus.LensStatusReady
    | typeof MyLensesLensStatus.LensStatusAwaitingProductTagging;

// pick community lenses types
export type PaginationFilterStatus = Exclude<
    MyLensesLensStatus,
    BusinessLensStatuses | typeof MyLensesLensStatus.LensStatusUnset
>;

export const LensSpaceLensFilterStatuses: Partial<Record<PaginationFilterStatus, PaginationFilterStatus>> = {
    [MyLensesLensStatus.LensStatusLive]: MyLensesLensStatus.LensStatusLive,
    [MyLensesLensStatus.LensStatusOffline]: MyLensesLensStatus.LensStatusOffline,
    [MyLensesLensStatus.LensStatusInReview]: MyLensesLensStatus.LensStatusInReview,
    [MyLensesLensStatus.LensStatusInvalid]: MyLensesLensStatus.LensStatusInvalid,
    [MyLensesLensStatus.LensStatusRejected]: MyLensesLensStatus.LensStatusRejected,
    [MyLensesLensStatus.LensStatusHidden]: MyLensesLensStatus.LensStatusHidden,
    [MyLensesLensStatus.LensStatusNotPublishedToSnapchat]: MyLensesLensStatus.LensStatusNotPublishedToSnapchat,
    [MyLensesLensStatus.LensStatusAvailable]: MyLensesLensStatus.LensStatusAvailable,
    [MyLensesLensStatus.LensStatusProcessing]: MyLensesLensStatus.LensStatusProcessing,
};

export interface PaginationFilter {
    readonly locked?: boolean;
    readonly statuses: readonly MyLensesLensStatus[];
    readonly searchName: string;
    readonly surfaceTypeList: readonly SurfaceType[];
}

export const defaultPaginationFilter: Readonly<PaginationFilter> = {
    statuses: [],
    searchName: "",
    surfaceTypeList: [],
};
